import { createTheme } from 'flowbite-react';
import { theme } from '../../Dropdown/Dropdown';

export const dropdownTheme = createTheme({
    dropdown: {
        ...theme,
        floating: {
            ...theme.floating,
            target: 'border-l-0 rounded-l-none bg-gray-200 border-gray-300 focus:ring-0 hover:!bg-gray-200 text-gray-600 px-2 py-0 h-auto !w-auto',
        },
    },
}).dropdown;
